/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.user.reset_password_modal.title': '重置密码',
  'pages.user.reset_password_modal.setting_button': '设置',
  'pages.user.reset_password_modal.password.password': '新密码',
  'pages.user.reset_password_modal.password.placeholder': '请输入新密码',
  'pages.user.reset_password_modal.password.rule.0.message': '密码不能为空',
  'pages.user.reset_password_modal.confirm_password': '确认新密码',
  'pages.user.reset_password_modal.confirm_password.placeholder': '请输入确认密码',
  'pages.user.reset_password.confirm_password.confirm_password.rule.0.message': '密码不能为空',
  'pages.user.reset_password.confirm_password.success': '修改成功，请重新登录',
  'pages.user.reset_password.confirm_password.jumping': '正在跳转...',
  'pages.user.reset_password.confirm_password.session_invalid': '会话无效，请重新登录',
};
